import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import PrimaryButtonCard from '../../components/PrimaryButtonCard/PrimaryButtonCard';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import { setInputType } from '../../redux/actions/result.action';
import { loadContentForPage, pushAndStop } from '../../redux/actions/text.action';
import './SelectInput.scss';

//icon
import searchIcon from '../../assets/say.png';
import keyboardIcon from '../../assets/keyboard.png';
import photoIcon from '../../assets/camera.png';

//text
import text from '../../assets/text/text.json';

/**
 * Select the input. Available inputs are text, speech and photo
 */
class SelectInput extends Component<{ navigateTo: any, setInput: any, setCurrentpage: any }, {}> {

    renderBody() {
        return (
            <div className="selectinput-container">
                <div className="selectinput-btn-container">
                    <PrimaryButtonCard icon={searchIcon} text="Sagen" action={() => { 
                        this.props.setInput('speak');
                        this.props.navigateTo('/inputspeech') }} />
                    <PrimaryButtonCard icon={keyboardIcon} text="Schreiben" action={() => {
                        this.props.setInput('text');
                        this.props.navigateTo('/inputtext')
                    }} />
                    <PrimaryButtonCard icon={photoIcon} text="Foto zeigen" action={() => { this.props.navigateTo('/inputphoto') }} />
                </div>
            </div>
        )
    }
    
    /**
     * Main render method of component
     */
    render() {
        return (
            <div className="selectinput">
                <PageTemplate assistantLine1={""} assistantLine2={text.eingabeMethode.Assistant.line1} body={this.renderBody()} page="eingabeMethode" text={["Sagen", "Schreiben", "Foto zeigen"]}/>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {

    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setInput(type: string) {
            dispatch(setInputType(type));
        },
        navigateTo(path: string) {
            dispatch(pushAndStop(path));
        },
        setCurrentpage() {
            dispatch(loadContentForPage("eingabeMethode"));
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectInput);